export enum QuestionnaireItemType {
	QUESTION = 'question',
	ANSWER = 'answer',
	ON_SUBMIT = 'on_submit',
	ITEM = 'item',
	TEXT = 'text',
	COLLAPSE = 'collapse',
}
